import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getModuleByIdStart } from "../../../Store/Slices/formSlice";
import { Dropdown, Modal } from "react-bootstrap";

const BillToContent = ({
    showQTBillToContent,
    setshowQTBillToContent,
    QTBillToValues,
    handleInsertQTBillToPlaceholder,
    handleQTBillToValuesChange,
    selectedModule
}) => {
    const dispatch = useDispatch();
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms)?.modules;

    let [billToPlaceholders, setBillToPlaceholders] = useState([]);
    let [fieldList, setFieldList] = useState([]);

    useEffect(() => {
        if (navbarList?.length) {
            let id = navbarList?.filter(item => item.name === selectedModule)?.[0]?._id
            if (id) {
                dispatch(getModuleByIdStart(id));
            }
        }
    }, [navbarList]);

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
    }, [formList])

    useEffect(() => {
        if (fieldList?.length > 0) {
            let fields = fieldList
                .map(data => ({ key: data.extra_fields.field_label, value: data.extra_fields.field_label }))
            if (fields) {
                let newItem = {
                    categoryTitle: selectedModule.toUpperCase(),
                    items: fields
                }
                setBillToPlaceholders(prevItems => {
                    const exists = prevItems.some(item => item.categoryTitle === selectedModule.toUpperCase());
                    if (!exists) {
                        return [...prevItems, newItem];
                    }
                    return prevItems;
                });
            }
        }
    }, [fieldList])

    return (
        <Modal show={showQTBillToContent} onHide={() => setshowQTBillToContent(false)} size="lg" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title className="font-17 fw-normal">
                    <span className="align-middle">Billing Address Format (Displayed in PDF only)</span>
                    {/* <TooltipTrig id="billOrShipAddressFormatInfo" placement={"right"}
                        title={<span className="pe-4 d-inline-block">Placeholders and characters like comma, space, -, ., : are allowed.</span>}>
                        <span className="ps-1 text-gray">
                            <GoQuestion size={20} />
                        </span>
                    </TooltipTrig> */}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* {billOrShipAddConfigShow ? (
                    <>
                        <textarea rows={9} id="billOrShip_add_format_input" className="form-control border-0 text-uppercase"
                            value={billOrShipAddCustomValues} disabled></textarea>
                        <div className="mt-2 form-text text-muted">
                            This is the common address format. To edit this address format, go to
                            <span className="fw-semibold ps-1">Settings &gt; Preferences &gt; Customers and Vendors</span>.
                        </div>
                        <div className="mt-4 mb-0 alert alert-light d-flex align-items-center" role="alert">
                            <div className="text-info">
                                <i className="fa-solid fa-circle-info fs-5"></i>
                            </div>
                            <div className="ms-2 small">
                                Do you want to have a custom address format only for this template ?
                            </div>
                            <div className="ms-auto">
                                <button type="button" className="btn btn-link text-decoration-none small px-0"
                                    onClick={() => setBillOrShipAddConfigShow()}>
                                    <Settings size={16} /> <span className="ps-1">Configure</span>
                                </button>
                            </div>
                        </div>
                    </>
                ) : ( */}
                <>
                    <div className="card p-0">
                        <div className="card-header d-flex justify-content-between">
                            <Dropdown>
                                <Dropdown.Toggle variant="light" className="with-arrow px-3" id="billOrShipCont_dropdownBtn">
                                    <span className="pe-3">Insert Placeholder</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="max-h-400px">
                                    <div className="hstack align-items-start">
                                        {billToPlaceholders.map((categoryTitle, index) => (
                                            <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                                <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                                {categoryTitle.items.map((item, itemIndex) => (
                                                    <Dropdown.Item key={itemIndex} onClick={() => handleInsertQTBillToPlaceholder(categoryTitle.categoryTitle, item.value)}>
                                                        {item.value}
                                                    </Dropdown.Item>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <textarea rows={9} id="billOrShip_cont_input" className="form-control border-0 text-uppercase"
                            value={QTBillToValues} onChange={handleQTBillToValuesChange}></textarea>
                    </div>
                    <div className="mt-3 alert alert-warning d-flex" role="alert">
                        <div className="text-warning">
                            <i className="fa-solid fa-circle-info fs-6"></i>
                        </div>
                        <div className="ms-2 small pe-3">
                            This custom address format will be used only in this template.
                            If you leave the custom address format empty,
                            the common address format will be used.
                        </div>
                    </div>
                </>
                {/* )} */}
            </Modal.Body>
            {/* <Modal.Footer>
                {billOrShipAddConfigShow ? (
                    <Button variant="outline-secondary" className="py-1 me-auto" onClick={billOrShipAddressModalClose}>
                        Close
                    </Button>
                ) : (
                    <>
                        <Button variant="primary" className="py-1" onClick={billOrShipAddressModalClose}>
                            Preview
                        </Button>
                        <Button variant="outline-secondary" className="py-1" onClick={billOrShipAddressModalClose}>
                            Cancel
                        </Button>
                        <Button variant="link" type="reset" className="p-0 py-2 ms-auto text-decoration-none"
                            onClick={() => setBillOrShipAddConfigShow(true)}>Use Common Format</Button>
                    </>
                )}
            </Modal.Footer> */}
        </Modal>
    )
}
export default BillToContent;